import { render, staticRenderFns } from "./MdtModalConfirmation.vue?vue&type=template&id=1985bead&scoped=true"
import script from "./MdtModalConfirmation.vue?vue&type=script&lang=js"
export * from "./MdtModalConfirmation.vue?vue&type=script&lang=js"
import style0 from "./MdtModalConfirmation.vue?vue&type=style&index=0&id=1985bead&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1985bead",
  null
  
)

export default component.exports